import React from 'react'
import { useTranslation } from 'react-i18next'

import DOMPurify from 'isomorphic-dompurify'
import useClinic from '@hooks/useClinic'
import { isP21ClinicWithExternalWebsiteWithNoGeneralTermsAndConditions, useLegalLinks } from '@hooks/useLegalLinks'
import { useSelectedClinicId } from '@hooks/useSelectedClinicId'
import { useConfig } from '@context/ConfigurationContext'

interface Props {
  className?: string
}

const DataUsageLabel = ({ className }: Props) => {
  const { t } = useTranslation()
  const clinicId = useSelectedClinicId()
  const { data: clinic } = useClinic(clinicId)
  const { privacyLink, generalTermsAndConditionsLink } = useLegalLinks()
  const { isInternalClinic } = useConfig()

  const getLabelHtmlForInternalClinics = () =>
    isP21ClinicWithExternalWebsiteWithNoGeneralTermsAndConditions(clinicId)
      ? DOMPurify.sanitize(t('data_usage_v3', { link: privacyLink }), {
          ADD_ATTR: ['target'],
        })
      : DOMPurify.sanitize(
          t('data_usage_v4', { privacyLink, generalTermsAndConditionsLink, clinicName: clinic?.officialName }),
          {
            ADD_ATTR: ['target'],
          }
        )

  const getLabelHtmlForExternalClinics = () =>
    DOMPurify.sanitize(t('data_usage_external_clinic', { generalTermsAndConditionsLink }), {
      ADD_ATTR: ['target'],
    })

  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{
        __html: isInternalClinic ? getLabelHtmlForInternalClinics() : getLabelHtmlForExternalClinics(),
      }}
    ></span>
  )
}

export default DataUsageLabel
